/* unplugin-vue-components disabled */import script from "./informedConsent.vue?vue&type=script&lang=ts&setup=true"
export * from "./informedConsent.vue?vue&type=script&lang=ts&setup=true"

import "./informedConsent.vue?vue&type=style&index=0&id=a2f6932e&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2f6932e"]])

export default __exports__